










































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';

@Component
export default class CardBalance extends CompanyMixin {
    rows: any = [
        {text: 'TILLGÅNGAR',                            values: [],             styles: ['title']},
        {text: 'Tecknat men ej inbetalt kapital',       values: ['A', 'L'],     styles: ['', '', '']},
        {text: 'Anläggningstillgångar',                 values: [],             styles: ['title']},
        {text: 'Immateriella anläggningstillgångar',    values: ['B', 'L'],     styles: ['t', '', '']},
        {text: 'Materiella anläggningstillgångar',      values: ['C', 'L'],     styles: ['t', '', '']},
        {text: 'Finansiella anläggningstillgångar',     values: ['D', 'L'],     styles: ['t', ' line', ' line']},
        {text: 'Summa anläggningstillgångar',           values: ['E', 'L'],     styles: ['sum', 'bline', 'line']},
        {text: 'Omsättningstillgångar',                 values: [],             styles: ['title']},
        {text: 'Varulager m.m.',                        values: ['F', 'L'],     styles: ['t']},
        {text: 'Kundfordringar',                        values: ['G', 'L'],     styles: ['t']},
        {text: 'Övriga kortfristiga fordringar',        values: ['H', 'L'],     styles: ['t']},
        {text: 'Kortfristiga placeringar',              values: ['I', 'L'],     styles: ['t']},
        {text: 'Kassa och bank',                        values: ['J', 'L'],     styles: ['t', 'line', 'line']},
        {text: 'Summa omsättningstillgångar',           values: ['K', 'L'],     styles: ['sum', 'bline', 'line']},
        {text: 'SUMMA TILLGÅNGAR',                      values: ['L', 'L'],     styles: ['sum', 'bline', 'line']},
        {text: 'EGET KAPITAL OCH SKULDER',              values: [],             styles: ['title']},
        {text: 'Eget kapital',                          values: ['M', 'S'],     styles: ['']},
        {text: 'Obeskattade reserver',                  values: ['N', 'S'],     styles: ['']},
        {text: 'Avsättningar',                          values: ['O', 'S'],     styles: ['']},
        {text: 'Skulder',                               values: [],             styles: ['title']},
        {text: 'Långfristiga skulder',                  values: ['P', 'S'],     styles: ['t']},
        {text: 'Kortfristiga skulder',                  values: ['Q', 'S'],     styles: ['t', 'line', 'line']},
        {text: 'Summa skulder',                         values: ['R', 'S'],     styles: ['sum', 'bline', 'line']},
        {text: 'SUMMA EGET KAPITAL OCH SKULDER',        values: ['S', 'S'],     styles: ['sum', 'bline', 'line']},
    ];
    cols: any = [];

    val(i: number, row: any) {
        const name = row.values[0];
        if (name === undefined) {
            return '';
        }
        return this.balance.sheets[i][name];
    }

    part(i: number, row: any) {
        const name1 = row.values[0];
        const name2 = row.values[1];
        if (name1 === undefined || name2 === undefined) {
            return '';
        }
        const n1 = Number(this.balance.sheets[i][name1]);
        const n2 = Number(this.balance.sheets[i][name2]);
        if (n2 === 0) {
            return 0;
        }
        return n1 / n2;
    }

    title(i: number) {
        return this.balance.sheets[i].DATE_TO.substr(0, 7) + ' (' + this.balance.sheets[i].MONTHS + ' mån)';
    }

    @Watch('balance', { immediate: true, deep: true })
    onBalanceChanged(newVal: any, oldVal: any) {
        this.cols.splice(0, this.cols.length);
        if (this.balance !== undefined) {
            for (let i = 0; i < this.balance.count; i++) {
                this.cols.push(i);
            }
        }
    }

}
